import styled from 'styled-components';

export const EmptyContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(6)};
`;
